import { InvitationStatus } from "./enums";

export type { InvitationStatus };

export type NotificationMethod = "EMAIL" | "SMS" | "BOTH";

export type DoctorInvitationRequest = {
  firstName: string;
  lastName: string;
  email?: string;
  phoneNumber?: string;
  specialties?: string[];
  notificationMethod: NotificationMethod;
  /** MED-1695: days of free trial on acceptance, 0 to 90; the API defaults to 14 when absent. */
  trialDays?: number;
};

export type BulkDoctorInvitationRequest = {
  invitations: DoctorInvitationRequest[];
  /** MED-1695: one trial length for the whole batch. */
  trialDays?: number;
};

/** MED-1695: bounds the API enforces on a trial length (INVITATION_TRIAL_DAYS_INVALID). */
export const DEFAULT_TRIAL_DAYS = 14;
export const MAX_TRIAL_DAYS = 90;

export type DoctorInvitationDto = {
  id: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  specialties?: string;
  token: string;
  status: InvitationStatus;
  notificationMethod: NotificationMethod;
  expirationDate: string;
  invitedAt: string;
  acceptedAt?: string;
  resendCount: number;
  invitedByAdminId: number;
  firstClickedAt?: string;
  clickCount?: number;
  /** MED-1695: days of free trial granted on acceptance; 0 = none. */
  trialDays?: number;
};

export type DoctorInvitationEventDto = {
  id: number;
  eventType: string;
  outcome: string;
  createdAt: string;
};

export type BulkRowError = {
  row: number;
  email?: string | null;
  phoneNumber?: string | null;
  value?: string | null;
  errorCode: string;
};
